// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/airframe-construction.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/airframe-construction/airframe-construction.js';

mount([g0]);
